module.exports = __webpack_public_path__ + "img/1F61C.c6433914.svg";